module.exports = {
          srcSet: __webpack_public_path__ + "eb2a4cb68606ae9fbca64a40280d27bc-168.png"+" 168w",
          images:[ {path: __webpack_public_path__ + "eb2a4cb68606ae9fbca64a40280d27bc-168.png",width: 168,height: 173}],
          src: __webpack_public_path__ + "eb2a4cb68606ae9fbca64a40280d27bc-168.png",
          toString:function(){return __webpack_public_path__ + "eb2a4cb68606ae9fbca64a40280d27bc-168.png"},
          
          width: 168,
          height: 173
        }